import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'nsp-menubar-item',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenubarItemComponent {
  label = input.required<string>();
  url = input.required<string>();
  icon = input.required<string>();
}
